export default {
  "Stop Streaming": "Arrêter le streaming",
  "Are you sure you want to stop your live stream?": "Êtes-vous sûr de vouloir arrêter votre diffusion en direct ?",
  "Cancel": "Annuler",
  "Stop": "Arrêter",

  "Start Streaming": "Démarrer le streaming",
  "Change your live duration": "Modifier la durée de votre direct",
  "Start": "Démarrer",
  "Change": "Modifier",
  "Select your live duration": "Sélectionnez la durée de votre direct",
  "You don't have enough available hours to complete a": "Vous n'avez pas assez d'heures disponibles pour effectuer un",
  "Buy extra hours": "Acheter des heures",
  "You can't lower the live duration in the past!": "Vous ne pouvez pas réduire la durée du direct dans le passé !",
  "You can manually stop your live at any time.": "Vous pouvez arrêter manuellement votre direct à tout moment.",
  "Your live will automatically stop at": "Votre direct s'arrêtera automatiquement à",

  "remaining": "restantes",
  "Change live duration": "Modifier la durée du direct",
  "Live broadcast ended | Live broadcast ending soon | Live broadcast ending in less than {count} minutes":
    "Direct terminé | Fin du direct imminente | Fin du direct dans moins de {count} minutes",

  "automatically stops at": "s'arrête automatiquement à",
  "You cannot start this project": "Vous ne pouvez pas démarrer ce projet",
  "Please contact support@vodalys.com for more information": "Veuillez contacter support@vodalys.com pour plus d'informations",
  "Ok": "Ok"
}
